import Util from '../RegistrationUtil'
import Field from '../RegistrationField'

function VisitorType(opts) {
    Field.call(this, opts)

    this.itemByValue = this.list.reduce(function(map, item) {
        map[item.value] = item
        return map
    }, {})
}

Util.inherit(VisitorType, Field, {
    getClassName: function() {
        return 'visitortype'
    },

    buildHtml: function() {
        var list = this.list

        var mainItems = []
        var childItems = {}

        for (var i = 0, ii = list.length; i < ii; ++i) {
            var item = list[i]
            var pg = item.parent_type

            if (pg) {
                // create array if not exists
                ;(childItems[pg] || (childItems[pg] = [])).push(item)
            } else {
                mainItems.push(item)
            }
        }

        if (this.registration.useSelectForVisitorType) {
            var html = '<select name="visitortype" id="' + this._getId() + '">'
            html += '<option value="">' + Util.escape(this.title) + '...' + '</option>'
            for (var i = 0; i < mainItems.length; i++) {
                var item = mainItems[i]
                var k = item.value
                if (childItems[k]) {
                    for (var j = 0; j < childItems[k].length; j++) {
                        var child = childItems[k][j]
                        var full_title = this._formatString(child.title_above) + ' ' + this._formatString(child.title)
                        html += '<option value="' + child.value + '">' + full_title + '</option>'
                    }
                } else {
                    var full_title = this._formatString(item.title_above) + ' ' + this._formatString(item.title)
                    html += '<option value="' + item.value + '">' + full_title + '</option>'
                }
            }
            html += '</select>'
            return html
        }

        // NOTE : min-width must be set to 100px
        //        because there's some issue with
        //        jquery/forms when we initially
        //  	  hide other fields
        var html =
            '<div class="visible_area" style="min-width:100px;" tabindex="0" role="button"><div class="text"></div></div>'

        html += '<div class="visitortype-grid-wrapper">'

        // build main grid
        html += this._buildMainGrid(mainItems)

        // build child grids
        for (var pg in childItems) {
            html += this._buildChildGrid(pg, childItems[pg])
        }

        html += '</div>'

        var svg = ''
        if (this.registration.isMaterialUI()) {
            svg = this.registration.getSvg('downArrow2')
        } else {
            svg = this.registration.getSvg('downArrow')
        }
        html += '<div class="svg-icon-wrap">' + svg + '</div>'

        return html
    },

    /**
     * Protected - apply bindings to field
     */
    applyBindings: function() {
        var self = this
        var $select = this.$html.find('select')
        if ($select.length > 0) {
            $select.on('change', function(e) {
                self.setValue($(this).val())
            })
            $select.on('focus', this.focus.bind(this))
            $select.on('blur', this.blur.bind(this))
            return
        }

        var self = this
        var $gridWrap = this.$html.find('.visitortype-grid-wrapper')

        function showMainGrid() {
            /* ensure made class is not hidden */
            $gridWrap.show()
            $gridWrap.find('.grid.main-grid').show()
            $gridWrap.addClass('show')
            /* Hide children so we can't tab them */
            $gridWrap.find('.grid.child-grid').removeClass('show')
            $gridWrap.find('.grid.child-grid').hide()
            self.focus()
        }

        function showChildGrid(vtype) {
            var $parent = $gridWrap.find('.grid.main-grid')
            var $child = $gridWrap.find('.grid.child-grid[child-to="' + vtype + '"]')
            if ($child.length > 0) {
                $child.show()
                $gridWrap.addClass('show')
                $child.addClass('show')
                self.focus()
                /* Ensure our tabing doesn't focus on background items */
                setTimeout(function() {
                    $parent.hide()
                }, 200)
            }

            return $child.length > 0
        }

        function hideGrid() {
            $gridWrap.removeClass('show')
            $gridWrap.hide()
            self.blur()
        }

        // CLOSE GRID WHEN CLICKING OUTSIDE
        this.registration.onDialogClick(function(evt) {
            if ($gridWrap.hasClass('show')) {
                if ($(evt.target).closest('.registration-field[fieldid="' + self.id + '"]').length === 0) {
                    hideGrid()
                }
            }
        })

        this.$html.find('.visible_area').on('click touchstart keyup', function(e) {
            e.preventDefault()
            if ($gridWrap.hasClass('show')) {
                // TOGGLE HIDE
                hideGrid()
            } else {
                // TOGGLE SHOW PRIMARY GRID
                setTimeout(showMainGrid, 100)
            }
            e.stopPropagation && e.stopPropagation()
            return false
        })

        $gridWrap.find('.grid.main-grid .grid-item').on('click touchstart keyup', function(evnt) {
            //We should process this event if it is not keyup || it is enter key
            var shouldProcess = 'keyup' != evnt.originalEvent.type || 13 == evnt.keyCode
            if (shouldProcess) {
                var vtype = $(this).attr('item-value')

                if (!showChildGrid(vtype)) {
                    self.setValue(vtype)

                    hideGrid()
                }
                evnt.stopPropagation && evnt.stopPropagation()
                return false
            }
        })

        $gridWrap.find('.grid.child-grid .grid-item').on('click touchstart keyup', function(evnt) {
            //We should process this event if it is not keyup || it is enter key
            var shouldProcess = 'keyup' != evnt.originalEvent.type || 13 == evnt.keyCode
            if (shouldProcess) {
                var vtype = $(this).attr('item-value')

                self.setValue(vtype)

                hideGrid()
                evnt.stopPropagation && evnt.stopPropagation()
                return false
            }
        })
    },

    /**
     * Protected
     */
    updateView: function() {
        Field.prototype.updateView.call(this)

        var text = ''
        var textField = this.$html.find('.visible_area .text')
        if (this.value) {
            var item = this.itemByValue[this.value]
            if (item) {
                text = this._formatString(item.title_above) + ' ' + this._formatString(item.title)

                text = $.trim(text)
                textField.addClass('visitor_type_selected')
            }
        } else {
            text = this.title + '...' + (this.required ? ' *' : '')
            if (textField.hasClass('visitor_type_selected')) {
                textField.removeClass('visitor_type_selected')
            }
        }

        this.$html.find('.visible_area .text').text(text)
        this.$html.find('.visible_area').attr('aria-label', text.replace('...', '').replace('*', '') + ' selection.')
    },

    _buildMainGrid: function(items) {
        // we always want 2 rows, but the number of columns can change, depending on
        // the length of main grid items
        var middle = Math.ceil(items.length / 2)

        var row0 = items.slice(0, middle)
        var row1 = items.slice(middle)

        var html = '' + '<div class="grid main-grid">' + this._buildGridRow(row0) + this._buildGridRow(row1) + '</div>'

        return html
    },

    _buildChildGrid: function(parent_type, items) {
        var html =
            '' +
            '<div class="grid child-grid" child-to="' +
            Util.escape(parent_type) +
            '">' +
            this._buildGridRow(items) +
            '</div>'

        return html
    },

    _buildGridRow: function(items) {
        var html = '<table class="grid-row"><tbody><tr>'

        for (var i = 0, ii = items.length; i < ii; ++i) {
            var item = items[i]
            var title_above = this._formatString(item.title_above)
            var title = this._formatString(item.title)
            var full_title = title_above + ' ' + title
            var svg = this.registration.getSvg(item.icon)

            var iconClass = title_above ? 'compact' : 'full'

            html +=
                '' +
                '<td class="grid-item" item-value="' +
                Util.escape(item.value) +
                '" tabindex="0" role="button" alt="' +
                full_title +
                '" >' +
                (title_above ? '<div class="text top">' + Util.escape(title_above) + '</div>' : '') +
                (svg ? '<div class="icon ' + iconClass + '">' + svg + '</div>' : '') +
                (title ? '<div class="text bottom">' + Util.escape(title) + '</div>' : '') +
                '</td>'
        }

        html += '</tr></tbody></table>'

        return html
    },

    _formatString: function(str) {
        str = str || ''

        if (str === '{{loc_name}}') {
            str = this.registration.loc_name
        }
        return str
    },
})

export default VisitorType
